var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lite-button",class:_vm.getHoverClasses},[_c('i',{staticClass:"lite-button-icon",class:_vm.iconClass}),_c('p',{staticClass:"lite-button-label",domProps:{"textContent":_vm._s(_vm.buttonText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }